import { Check } from "lucide-react";
import { LEAD_MAGNET } from "@/content/copy";
import ChecklistForm from "@/components/site/ChecklistForm";

export default function LeadMagnet() {
  return (
    <section id="checklist" data-testid="lead-magnet-section" className="py-20 lg:py-32 bg-terracotta-light">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <p className="text-sm font-bold uppercase tracking-widest text-terracotta">{LEAD_MAGNET.overline}</p>
            <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-navy">{LEAD_MAGNET.title}</h2>
            <p className="mt-4 text-base text-navy/70 leading-relaxed">{LEAD_MAGNET.text}</p>
            <ul className="mt-6 space-y-3">
              {LEAD_MAGNET.bulletPoints.map((point) => (
                <li key={point} className="flex gap-3 text-sm font-semibold text-navy/80">
                  <Check className="w-4 h-4 mt-0.5 shrink-0 text-terracotta" aria-hidden="true" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-2xl bg-white p-8 shadow-lg">
            <h3 className="text-xl font-semibold text-navy">{LEAD_MAGNET.formTitle}</h3>
            <div className="mt-5">
              <ChecklistForm idPrefix="lead-magnet" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
